import { getOption } from "./Options/Options";

export enum LogLevel {
    ESSENTIAL,
    NORMAL,
    VERBOSE,
}

export const getLogLevel = (): LogLevel => {
    if(__VERSION__.type === "development") {
        return LogLevel.VERBOSE;
    }

    switch(getOption("ui_logging_level")) {
        case "verbose":
            return LogLevel.VERBOSE;
        case "normal":
            return LogLevel.NORMAL;
    }

    return LogLevel.ESSENTIAL;
};
